import { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import Intro from "@/components/service/components/intro/Intro";
import WebBanner from "@/components/service/components/banner/WebBanner";
import WebSlider from "@/components/service/web-design/web-slider/WebSlider";
import PriceList from "@/components/service/components/price-list/PriceList";
import InfoList from "@/components/service/components/info-list/InfoList";
import priceList from "@/data/services/e-commerce/price-list.json";
import infoList from "@/data/services/e-commerce/info-list.json";
import infoData from "@/data/services/e-commerce/intro.json";
import faq from "@/data/services/e-commerce/faq.json";
import data from "@/data/services/e-commerce/detail-slider.json";
import Faq from "@/components/contact/faq/Faq";
import PageSEO from "@/components/common/PageSEO";
import WebInfo from "@/components/service/web-design/web-info/WebInfo";
import Spacing from "@/components/common/Spacing";
import DynamicComparisonTable from "@/components/common/DynamicComparisonTable";
import { Row, Col } from "react-bootstrap";
import facebookIcon from "@/assets/facebook.png";
import instagramIcon from "@/assets/instagram.png";
import whatsappIcon from "@/assets/whatsapp.png";

const Commerce = () => {
  const [showComparison, setShowComparison] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const isCompact = typeof window !== "undefined" && window.innerWidth <= 480;
  
  const SliderRef = useRef<HTMLDivElement>(null);
  const comparisonRef = useRef<HTMLDivElement>(null);
  const showButtonRef = useRef<HTMLDivElement>(null);

  const scrollToRef = () => {
    if (SliderRef.current) {
      SliderRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToComparison = () => {
    setShowComparison(true);
    setTimeout(() => {
      if (comparisonRef.current) {
        comparisonRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const hideComparison = () => {
    setShowComparison(false);
    setTimeout(() => {
      if (showButtonRef.current) {
        showButtonRef.current.scrollIntoView({ 
          behavior: "smooth", 
          block: "center" 
        });
      }
    }, 100);
  };

  return (
    <>
      <PageSEO section="services" keyName="e-commerce" />
      <Intro data={infoData} />
      <Container style={{ height: "100%" }}>
        <WebBanner onClick={scrollToRef} img={infoData.img} />
        <WebInfo info={data} />
      </Container>
      <Spacing size={4} />
      <div ref={SliderRef}>
        <WebSlider info={data} />
      </div>
      <Container style={{ height: "100%" }}>
        <PriceList data={priceList} />
      </Container>
      
      {/* SOCIAL MEDIA SECTION - OUTSIDE PROBLEMATIC CONTAINER */}
      <Container style={{ 
        marginTop: isMobile ? '-5rem' : '-4rem'
      }}>
        <Row className="contact-submit-row">
          <Col xs={12} lg={6}>
            {/* Empty left side */}
          </Col>
          <Col className="submit-second-col" xs={12} lg={{ span: 4, offset: 2 }}>
            <Row className="body">Hai cu noi pe social media!</Row>
            <Row>
              <Col xs={4}>
                <a href="https://www.facebook.com/pixadoagency" target="_blank" rel="noopener noreferrer">
                  <img src={facebookIcon} className="contact-dot" alt="Facebook" />
                </a>
              </Col>
              <Col xs={4}>
                <a href="https://www.instagram.com/pixadoagency/" target="_blank" rel="noopener noreferrer">
                  <img src={instagramIcon} className="contact-dot" alt="Instagram" />
                </a>
              </Col>
              <Col xs={4}>
                <a href="https://wa.me/40745371620" target="_blank" rel="noopener noreferrer">
                  <img src={whatsappIcon} className="contact-dot" alt="WhatsApp" />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      
      <Container style={{ height: "100%", marginTop: '-2rem' }}>
          
        {/* SHOW BUTTON ONLY WHEN TABLE IS HIDDEN */}
        {!showComparison && (
          <div 
            ref={showButtonRef}
            className="comparison-button-container"
            style={{ 
              textAlign: 'center', 
              margin: isCompact ? '60px 0 40px 0' : '40px 0',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <button
              className="button body"
              onClick={scrollToComparison}
              style={{
                position: 'relative',
                bottom: 'auto',
                left: 'auto',
                width: 'auto',
                height: 'auto',
                padding: '12px 24px',
                minWidth: '200px'
              }}
            >
              <span style={{ 
                position: 'relative', 
                zIndex: 10 
              }}>
                Vezi tabel comparativ side-by-side
              </span>
            </button>
          </div>
        )}

        {/* SHOW TABLE WHEN STATE IS TRUE */}
        {showComparison && (
          <>
            <div ref={comparisonRef} id="comparison">
              <DynamicComparisonTable 
                fileUrl="/data/shop.tiers.xlsx"
                title="CC Shop - Comparatie Completa"
                className="shop-comparison"
              />
            </div>
            
            {/* HIDE BUTTON BELOW TABLE */}
            <div 
              className="comparison-button-container"
              style={{ 
                textAlign: 'center', 
                margin: '40px 0',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <button 
                className="button body" 
                onClick={hideComparison}
                style={{
                  position: 'relative',
                  bottom: 'auto',
                  left: 'auto',
                  width: 'auto',
                  height: 'auto',
                  padding: '12px 24px',
                  minWidth: '200px'
                }}
              >
                <span style={{ 
                  position: 'relative', 
                  zIndex: 10 
                }}>
                  Inchide tabelul
                </span>
              </button>
            </div>
          </>
        )}

        <InfoList data={infoList} />
        <Faq data={faq} />
      </Container>
    </>
  );
};

export default Commerce;
